import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

export const MerchantsShowFiltersSkeleton: React.FC = () => (
  <Box sx={{ marginBottom: '20px' }}>
    <Skeleton height={40} variant="rounded" width="100%" />
  </Box>
);
